module.exports = __webpack_public_path__ + "07_medium_brown.0a9a0bf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/07_medium_brown.png
// module id = FPX9
// module chunks = 0